import { createTheme, Theme as MuiTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    customProps: {
      primaryColor: string;
      borderWidth: string;
    }
  }
  interface ThemeOptions {
    customProps: {
      primaryColor: string;
      borderWidth: string;
    }
  }
}

export const createAppTheme = (newDesign: boolean): MuiTheme => {
  return createTheme({
    customProps: {
      primaryColor: newDesign ? '#0E2F6C' : '#1976d2',
      borderWidth: newDesign ? '1.5px' : '1px',
    },
    palette: {
      primary: {
        main: newDesign ? '#0E2F6C' : '#1976d2',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '3px',
            height: '34px',
            fontSize: '15px',
            textTransform: 'none',
          },
        },
      },
    },
  });
};